import type { UseQueryResult } from '@tanstack/react-query';

import { EmptyStateView } from '../../../components/EmptyStateView';
import type { Contact } from '../../../domain/contact';
import { ContactItem } from '../ContactItem';

import { ScrollInfo } from './ScrollInfo';
import { StyledContactList, StyledContactListBackground } from './styles';

type ContactListProps = Pick<UseQueryResult<Contact[]>, 'data' | 'isError'> & {
  withCompanyName?: boolean;
  showScrollInfo?: boolean;
  shouldAnimatePrivateDataMount: boolean;
};

export const ContactList = (props: ContactListProps) => {
  const { data: contacts = [], isError, withCompanyName, showScrollInfo, shouldAnimatePrivateDataMount } = props;
  const hasContacts = !!contacts.length;

  if (!hasContacts || isError) {
    return <EmptyStateView variant="lens-small" img="/images/empty-state-lens.svg" messageKey="contacts.empty_state" />;
  }

  return (
    <StyledContactList data-automation="ContactList">
      <StyledContactListBackground data-automation="ContactListBg">
        {contacts.map((contact) => (
          <ContactItem
            key={contact.id || contact.linkedinId || contact.linkedinSalesNavId || contact.name}
            contact={contact}
            withCompanyName={withCompanyName}
            shouldAnimatePrivateDataMount={shouldAnimatePrivateDataMount}
          />
        ))}
        {showScrollInfo ? <ScrollInfo /> : null}
      </StyledContactListBackground>
    </StyledContactList>
  );
};
